module.exports = __webpack_public_path__ + "img/Expo-Summit-Coming-soon.7088652a.png";